// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"435":"a6469438","834":"5955f784"}[chunkId] + ".chunk.js";
};